import React from 'react';

function Header() {
    // mix-blend-difference keeps the header legible over both the dark home page and lighter inner pages.
    return (
        <header className="fixed inset-x-0 top-0 z-50 mix-blend-difference text-white">
            <div className="shell">
                <div className="flex items-center justify-between h-16 sm:h-20">
                    <a href="/" className="flex items-center gap-3 no-underline text-white" aria-label="Unit 326 — home">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                            <circle className="logo-ring" cx="12" cy="12" r="10" strokeWidth="1.2" transform="rotate(-90 12 12)" />
                            <path d="M9 7.5V13a3 3 0 0 0 6 0V7.5" strokeWidth="1.6" />
                        </svg>
                        <span className="mono" style={{ letterSpacing: '0.18em' }}>Unit 326</span>
                    </a>

                    <nav className="flex items-center gap-8">
                        <a href="/#work" className="mono text-white no-underline underline-draw">
                            Work
                        </a>
                        <a href="mailto:hello@unit326.com" className="mono text-white no-underline underline-draw">
                            Contact
                        </a>
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default Header;
